/* eslint-disable */
export default {
  createLog: 'Créer un journal',
  creating: 'Création en cours',
  save: 'Enregistrer',
  saving: 'Enregistrement',
  saved: 'Enregistré',
  view: 'Afficher',
  creatingFailed: 'Échec de la création.',
  savingFailed: 'Échec de l’enregistrement.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
